import { DOMINICA_TIMEZONE } from "../../constants/datetime";
import useIsOpen from "../../hooks/useIsOpen";
import {getNextOpeningStatusMessage} from "../../utils/payeeUtils"

const IsOpen = ({ openingHours = {}, timeZone = DOMINICA_TIMEZONE, lastOrderBuffer = "00:00" }) => {
    const { isOpen, nextOpeningTime, nextClosingTime } = useIsOpen(openingHours, timeZone, lastOrderBuffer);
    let statusText = getNextOpeningStatusMessage(isOpen, nextOpeningTime, nextClosingTime)
    return (
        <div>
            {isOpen ? (
                <div>
                    <span className="badge success">Open</span> {statusText}
                </div>
            ) : (
                <div>
                    <span className="badge error">Closed</span> {statusText}
                </div>
            )}
        </div>
    );
};

export default IsOpen;
